import jsSHA from 'jssha';

import type { Message } from '@swf/core/api/request';

export interface ResponseHeaders {
  contentLength: string;
  contentType: string;
  destination: string;
  messageId: string;
  replyId: string;
  subscription: string;
  type: string;
}

interface ChallengeResult {
  challengeResult: number[] | number;
  challengeResult2: number;
}

export const tryFetch = (url: string, options: RequestInit) =>
  fetch(url, options).then((response) => {
    if (!response.ok) {
      throw response;
    }
    return response;
  });

export const fetchText = (url: string, options = {} as RequestInit) =>
  fetch(url, options).then((response) => response.text());

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchJson = <T = any>(url: string, options = {} as RequestInit): Promise<T> =>
  fetch(url, options).then((response) => response.json());

export const fetchResponse = (url: string, options = {} as RequestInit) =>
  fetch(url, options).then((response) =>
    response.ok
      ? response.json()
      : response.text().then((data) => {
          throw new Error(data);
        })
  );

export const performPow = ({ challenge, difficulty, id, maxTries, script }: Message['body']) => {
  const challengeResult: ChallengeResult = {
    challengeResult: 0,
    challengeResult2: 0
  };

  const proofOfWork = new Function(script + 'return proofOfWork')();
  window.jsSHA = jsSHA;
  challengeResult.challengeResult = proofOfWork(challenge, difficulty, maxTries);
  delete window.jsSHA;
  if (challengeResult.challengeResult instanceof Array) {
    [challengeResult.challengeResult, challengeResult.challengeResult2] =
      challengeResult.challengeResult;
  }

  const header = {
    challenge,
    id,
    ...challengeResult
  };
  return JSON.stringify(header);
};
